import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { getProfile } from "../../webServices/Apis";
import Loader from "../Loader/Loader";
import { message } from "antd";

const PrintMultiple = () => {
  const location = useLocation();
  const { allApprovedInvoices } = location.state || {};
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    contractorProfile();
  }, []);

  const contractorProfile = async () => {
    try {
      setLoading(true);
      const response = await getProfile();
      if (response?.data?.success) {
        setProfile(response?.data?.data);
      }
    } catch (error) {
      message.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')}-${date.getFullYear()}`;
  };

  const tableStyle = {
    fontFamily: "'Arial', sans-serif",
    fontSize: "16px",
    color: "#555",
    maxWidth: "800px",
    width: "100%",
    lineHeight: "24px",
    textAlign: "left",
    margin: "40px auto",
    border: "1px solid #eee",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
  };

  const cellStyle = {
    padding: "5px",
    verticalAlign: "top",
    color: "black",
    border: "1px solid #919191",
  };

  const headerCellStyle = {
    padding: "5px",
    verticalAlign: "top",
    background: "#9f9f9f",
    borderBottom: "1px solid #ddd",
    fontWeight: "bold",
    color: "white",
    border: "1px solid #919191",
  };

  const totalCellStyle = {
    borderBottom: "2px solid #9f9f9f",
    borderLeft: "2px solid #9f9f9f",
    borderRight: "2px solid #919191",
    padding: "10px",
    textAlign: "right",
    color: "black",
  };

  const subTotal = allApprovedInvoices?.reduce((sum, inv) => sum + Number(inv?.projectInvoice?.workingHours || 0), 0);
  const hstTotal = allApprovedInvoices?.reduce((sum, inv) => sum + Number(inv?.hstAmount || 0), 0);
  const totalAmount = allApprovedInvoices?.reduce((sum, inv) => sum + Number(inv?.projectInvoice?.amountPaid || 0), 0);

  const subcontractor = allApprovedInvoices?.[0];

  return (
    <div
      className="flex justify-center items-center h-screen w-screen fixed top-0 left-0"
      style={{ backgroundColor: "#f5f5f5" }}
    >
      {loading && <Loader />}
      {allApprovedInvoices?.length > 0 && subcontractor && profile && (
        <table style={tableStyle}>
          <tbody>
            <tr className="top">
              <td colSpan="4" style={{ background: "#eaeaea", padding: "0 0 0 10px" }}>
                <table style={{ width: "100%", textAlign: "left" }}>
                  <tr>
                    <td style={{ paddingBottom: "25px" }}>
                      <h3 style={{ margin: "5px 0" }}>Date</h3>
                      {formatDate(subcontractor?.projectInvoice?.createdAt)}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        background: "#9f9f9f",
                        color: "white",
                        paddingLeft: "10px",
                        paddingBottom: "25px",
                        width: "47%",
                      }}
                    >
                      <h3 style={{ margin: "5px 0" }}>Invoice#</h3>
                      Multiple
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td colSpan="3" style={{ padding: "15px 10px", paddingBottom: "40px", color: "black" }}>
                <h3 style={{ margin: "5px 0" }}>Pay to</h3>
                {subcontractor?.projectInvoice?.subContractorName} {subcontractor?.lastname}
                <br />
                {subcontractor?.subContractorCompany}
                <br />
                {(subcontractor?.street || subcontractor?.city || subcontractor?.code || subcontractor?.prov) && (
                  <>
                  {subcontractor?.street}, {subcontractor?.city}, {subcontractor?.code}, {subcontractor?.prov}
                  </>
                )}
                
                <br />
                {subcontractor?.hst && (
                  <>
                  HST #: {subcontractor?.hst}
                  </>
                )}
                
              </td>
              <td style={{ padding: "15px 10px", paddingBottom: "40px", color: "black", width: "43%" }}>
                <h3 style={{ margin: "5px 0" }}>Bill To</h3>
                {profile?.companyName}
                <br />
                {profile?.address}
              </td>
            </tr>

            {/* Description Header */}
            <tr>
              <td style={headerCellStyle}>Description</td>
              <td style={headerCellStyle}>Date Range</td>
              <td style={headerCellStyle}>Tasks</td>
              <td style={{ ...headerCellStyle, textAlign: "right" }}>Amount</td>
            </tr>

            {/* Loop through invoices */}
            {allApprovedInvoices?.map((invoice, idx) => (
              <tr key={idx}>
                <td style={cellStyle}>
                  {formatDate(invoice?.projectInvoice?.startDate)} -{" "}
                  {formatDate(invoice?.projectInvoice?.endDate)}
                </td>
                <td style={cellStyle}>{invoice?.projectInvoice?.assignProjectName}</td>
                
                {invoice?.projectTasks?.map((task)=> (
                  <tr>
                    <td style={cellStyle}>Project Id : {task?.projectNumber}</td>
                    <td style={cellStyle}>{task?.taskName}</td>
                    <td style={cellStyle}>${task?.taskBudget}</td>
                    </tr>
                ))}
                
                <td style={{ ...cellStyle, textAlign: "right" }}>
                  ${invoice?.projectInvoice?.workingHours || 0}
                </td>
              </tr>
            ))}

            {/* Totals */}
            <tr>
              <td colSpan="3"></td>
              <td style={totalCellStyle}>
                <b>Sub Total :</b> <span>${subTotal.toFixed(2)}</span>
              </td>
            </tr>
            <tr>
              <td colSpan="3"></td>
              <td style={totalCellStyle}>
                <b>HST Total :</b> <span>${hstTotal.toFixed(2)}</span>
              </td>
            </tr>
            <tr>
              <td colSpan="3"></td>
              <td style={{ ...totalCellStyle, fontSize: "20px" }}>
                <b>Total :</b> <span>${totalAmount.toFixed(2)}</span>
              </td>
            </tr>

            <tr>
              <td colSpan="4" style={{ textAlign: "right", fontSize: "18px", color: "#000" }}>
                <p>
                  I understand and have signed the Declaration of Insurance electronic form for this
                  invoice.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PrintMultiple;
